/* 🤖 this file was generated by svg-to-ts */
export const emperorIconPhone: {
  name: 'phone';
  data: string;
} = {
  name: 'phone',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0Z"/><path d="M4.496 9.232c1.536 3.04 3.968 5.472 7.008 7.008l2.336 -2.336c0.288 -0.288 0.704 -0.352 1.056 -0.256 1.184 0.384 2.464 0.608 3.776 0.608 0.576 0 1.056 0.48 1.056 1.056v3.712c0 0.576 -0.48 1.056 -1.056 1.056 -9.856 0 -17.856 -8 -17.856 -17.856 0 -0.576 0.48 -1.056 1.056 -1.056h3.712c0.576 0 1.056 0.48 1.056 1.056 0 1.312 0.224 2.592 0.608 3.776 0.096 0.352 0.032 0.768 -0.256 1.056l-2.336 2.336z" transform="translate(2, 1.5)"/></svg>`
};
